<template>
  <van-tabs type="card" color="#07C160" sticky :offset-top="100">
    <van-tab style="margin-top: 10px" title="下户信息" v-if="!isReadOnly">
      <van-collapse v-model="activate">
        <van-form  @failed="onFailed">
          <input type="text" v-model="form.id" style="display: none"/>
          <van-collapse-item title="下户尽调人员" name="6">
            <van-field
                    clearable
                    label="下户人员"
                    name="interviewName"
                    placeholder="请输入下户人员姓名"
                    v-model="form.interviewName"
                    required
                    :rules="[{ required: true, message: '请输入下户人员姓名' }]"
            />
          </van-collapse-item>
          <van-collapse-item title="借款人基本情况" name="1">
            <van-field
                clearable
                label="申请金额(万)"
                name="borrowAmount"
                placeholder="申请金额"
                type="number"
                required
                :readonly="isReadOnly"
                :rules="[{ required: true, message: '请填写申请金额' }]"
                v-model="form.borrowAmount"
            />
            <van-field
                clearable
                label="申请期限(月)"
                name="borrowTerm"
                required
                placeholder="申请期限"
                type="number"
                :readonly="isReadOnly"
                :rules="[{ required: true, message: '请填写申请期限' }]"
                v-model="form.borrowTerm"
            />
            <van-field
                    clearable
                    label="借款用途"
                    name="borrowPurpose"
                    placeholder="借款用途"
                    required
                    :readonly="isReadOnly"
                    :rules="[{ required: true, message: '请填写借款用途' }]"
                    v-model="form.borrowPurpose"
            />
            <van-field
                clearable
                label="还款来源"
                name="repaymentSource"
                placeholder="还款来源"
                required
                right-icon="records"
                :readonly="isReadOnly"
                v-model="form.repaymentSource"
                :rules="[{ required: true, message: '请选择还款来源' }]"
                @click-right-icon="showMuliplePopup('repaymentSource')"
            />
            <van-field
                clearable
                label="婚姻状况"
                name="maritalStatus"
                placeholder="婚姻状况"
                v-model="form.maritalStatus"
                right-icon="records"
                required
                :readonly="isReadOnly"
                :rules="[{ required: true, message: '请选择或填写婚姻状况' }]"
                @click-right-icon="showPopup('maritalStatus')"
            />
            <van-field
                clearable
                label="常住地址"
                name="houseResidenceEqOwnerCert"
                placeholder="请选择常住地址与房产证是否一致"
                :rules="[{ required: true, message: '请选择常住地址与房产证是否一致' }]"
                right-icon="records"
                required
                v-model="form.houseResidenceEqOwnerCert"
                @click-right-icon="showPopup('houseResidenceEqOwnerCert')"
                :readonly="isReadOnly"
            />

            <van-field
                v-show="form.houseResidenceEqOwnerCert"
                clearable
                label="实际住址"
                name="houseResidenceAddr"
                placeholder="请输入实际住址"
                v-model="form.houseResidenceAddr"
                :readonly="isReadOnly"
            >
            </van-field>
          </van-collapse-item>

          <van-cell-group inset>
            <van-cell title="房产地址" :value="`${house.province} ${house.city} ${house.district} ${house.detailedAdress}`" v-for="house in houses">
              <template #right-icon>
                <van-button size="small" type="primary" @click="handleMortgageEdit(house)" style="margin-left: 20px">{{isReadOnly?'抵押物下户信息查看':'抵押物下户信息完善'}}</van-button>
              </template>
            </van-cell>
          </van-cell-group>

          <van-collapse-item title="收入与负债情况" name="3">
            <van-field
                clearable
                label="单位性质"
                name="comNature"
                placeholder="单位性质"
                required
                right-icon="records"
                :readonly="isReadOnly"
                v-model="form.comNature"
                type="textarea"
                :rows="2"
                :rules="[{ required: true, message: '请选择或填写单位性质' }]"
                @click-right-icon="showPopup('comNature')"
            />
            <van-field
                v-if="!isSelfEmployed"
                clearable
                label="职务"
                name="comJob"
                placeholder="职务"
                required
                right-icon="records"
                v-model="form.comJob"
                :readonly="isReadOnly"
                :rules="[{ required: true, message: '请选择职务' }]"
                @click-right-icon="showPopup('comJob')"
            />

            <van-field
                    clearable
                    v-if="isSelfEmployed"
                    label="经营主体类型"
                    name="comType"
                    required
                    placeholder="经营主体类型"
                    right-icon="records"
                    v-model="form.comType"
                    :readonly="isReadOnly"
                    :rules="[{ required: true, message: '请选择或填写经营主体类型' }]"
                    @click-right-icon="showPopup('comType')"
            />
            <van-field
                    clearable
                    label="经营年限"
                    v-if="isSelfEmployed"
                    name="comOperateYears"
                    placeholder="经营年限"
                    required
                    right-icon="records"
                    :readonly="isReadOnly"
                    v-model="form.comOperateYears"
                    :rules="[{ required: true, message: '请选择或填写经营年限' }]"
                    @click-right-icon="showPopup('comOperateYears')"
            />
            <van-field
                    clearable
                    label="借款人关系"
                    v-if="isSelfEmployed"
                    name="comToRelational"
                    required
                    placeholder="借款人关系"
                    right-icon="records"
                    :readonly="isReadOnly"
                    v-model="form.comToRelational"
                    :rules="[{ required: true, message: '请选择或填写借款人关系' }]"
                    @click-right-icon="showPopup('comToRelational')"
            />

            <van-field
                    clearable
                    label="年营业收入(万/年)"
                    name="operatingRevenue"
                    placeholder="请输入年营业收入"
                    required
                    type="number"
                    :readonly="isReadOnly"
                    :rules="[{ required: true, message: '请输入年营业收入' }]"
                    v-model="form.operatingRevenue"
            />
            <van-field
                    clearable
                    label="年营业利润(万/年)"
                    name="operatingProfit"
                    placeholder="请输入年营业利润"
                    required
                    type="number"
                    :readonly="isReadOnly"
                    :rules="[{ required: true, message: '请输入年营业利润' }]"
                    v-model="form.operatingProfit"
            />
            <van-field
                    clearable
                    label="总负债(万)"
                    name="totalLiabilities"
                    placeholder="请输入总负债"
                    required
                    type="number"
                    :readonly="isReadOnly"
                    :rules="[{ required: true, message: '请输入总负债' }]"
                    v-model="form.totalLiabilities"
            />
            <van-field
                    clearable
                    label="每月还款总额(万)"
                    name="monthlyRepayment"
                    placeholder="请输入每月还款总额"
                    required
                    type="number"
                    :readonly="isReadOnly"
                    :rules="[{ required: true, message: '请输入每月还款总额' }]"
                    v-model="form.monthlyRepayment"
            />
            <van-field
                    clearable
                    label="是否有其他收入"
                    name="ifOtherIncome"
                    placeholder="请选择是否有其他收入"
                    required
                    right-icon="records"
                    :readonly="isReadOnly"
                    v-model="form.ifOtherIncome"
                    :rules="[{ required: true, message: '请选择是否有其他收入' }]"
                    @click-right-icon="showPopup('ifOtherIncome')"
            />
            <van-field
                    clearable
                    label="其他收入"
                    name="otherIncome"
                    :readonly="isReadOnly"
                    v-if="ifOtherIncome"
                    v-model="form.otherIncome"
                    :rules="[{ required: true, message: '请填写其他收入' }]"
                    placeholder="请填写其他收入"
            />
            <van-field
                clearable
                label="家庭年收入"
                name="familyIncome"
                placeholder="家庭年收入"
                right-icon="records"
                :readonly="isReadOnly"
                v-model="form.familyIncome"
                :rules="[{ required: true, message: '请选择或填写家庭年收入' }]"
                @click-right-icon="showPopup('familyIncome')"
            />
          </van-collapse-item>

          <van-collapse-item title="转贷情况" name="4">
            <van-field
                clearable
                label="转贷类型"
                name="relendType"
                placeholder="转贷类型"
                required
                right-icon="records"
                v-model="form.relendType"
                :readonly="isReadOnly"
                :rules="[{ required: true, message: '请选择转贷类型' }]"
                @click-right-icon="showPopup('relendType')"
            />
            <template v-if="relendTypeShow">
            <van-field
                    clearable
                    label="转贷原因"
                    name="relendNote"
                    required
                    v-model="form.relendNote"
                    :rules="[{ required: true, message: '请填写转贷原因' }]"
                    :readonly="isReadOnly"
                    placeholder="转贷原因"
            />
            <van-field
                clearable
                label="上家借款(万)"
                name="previousAmount"
                placeholder="上家借款金额"
                :readonly="isReadOnly"
                required
                :rules="[{ required: true, message: '请输入上家借款金额' }]"
                v-model="form.previousAmount"
            />
            <van-field
                clearable
                label="上家还款情况"
                name="previousRepayStatus"
                placeholder="上家还款情况"
                required
                right-icon="records"
                v-model="form.previousRepayStatus"
                :readonly="isReadOnly"
                :rules="[{ required: true, message: '请选择上家还款情况' }]"
                @click-right-icon="showPopup('previousRepayStatus')"
            />
            </template>
            <van-field
                clearable
                label="逾期情况"
                name="previousRepayOverdue"
                type="textarea"
                required
                :rows="2"
                v-if="isOverdue"
                :readonly="isReadOnly"
                v-model="form.previousRepayOverdue"
                :rules="[{ required: true, message: '请选择' }]"
                placeholder="逾期情况"
            />

          </van-collapse-item>
          <van-collapse-item title="综述" name="5">
            <van-field
                clearable
                label="核验原件"
                name="checkedCardID"
                placeholder="核验原件"
                required
                :rules="[{ required: true, message: '请填写或选择核验原件或' }]"
                right-icon="records"
                type="textarea"
                rows="1"
                v-model="form.checkedCardID"
                @click-right-icon="showMuliplePopup('checkedCardID')"
            />
            <van-field
                clearable
                label="客户配合度"
                name="customerCooperation"
                placeholder="客户配合度"
                right-icon="records"
                required
                :readonly="isReadOnly"
                :rules="[{ required: true, message: '请选择客户配合度' }]"
                v-model="form.customerCooperation"
                @click-right-icon="showPopup('customerCooperation')"
            />
            <van-field
                clearable
                label="其他情况与异常"
                name="riskStatement"
                placeholder="其他情况与异常"
                rows="5"
                required
                :readonly="isReadOnly"
                :rules="[{ required: true, message: '请填写其他情况与异常' }]"
                type="textarea"
                v-model="form.riskStatement"
            />
          </van-collapse-item>

          <div style="margin: 16px;" v-if="!isReadOnly">
            <van-button round block :loading="loading" type="info" native-type="submit" @click="onSubmit">
              保存
            </van-button>
          </div>
        </van-form>
      </van-collapse>
    </van-tab>
    <van-tab style="margin-top: 10px" title="下户信息" v-if="isReadOnly">
      <!-- 借款人基本情况 -->
      <van-divider content-position="center">借款人基本情况</van-divider>
      <van-cell-group>
        <van-cell title="申请金额(万)" :value="data.borrowAmount" />
        <van-cell title="申请期限(月)" :value="data.borrowTerm" />
        <van-cell title="借款用途" :value="data.borrowPurpose" />
        <van-cell title="还款来源" v-if="data.repaymentSource" :value="data.repaymentSource" />
        <van-cell title="婚姻状况" :value="data.maritalStatus" />
        <van-cell title="常住地址" :value="data.houseResidenceEqOwnerCert" />
        <van-cell title="实际住址" v-if="data.houseResidenceAddr" :value="data.houseResidenceAddr" />
      </van-cell-group>

      <!-- 抵押物基本情况 -->
      <van-divider content-position="center">抵押物基本情况</van-divider>
      <div v-for="(item, index) in houses" :key="index">
        <van-cell-group>
          <van-cell
                  :title="'抵押物' + (index + 1)"
                  :label="item.province + item.district + item.city + item.detailedAdress"
                  clickable
          >
          </van-cell>
        </van-cell-group>

        <!-- 小区情况 -->
        <van-divider content-position="center">小区情况</van-divider>
        <van-cell-group>
          <van-cell title="小区名称" :value="item.estateName" />
          <van-cell title="小区情况" :value="item.houseEstateStatus" />
          <van-cell title="交通情况" :value="item.houseRafficSituation" />
          <van-cell title="所在楼层" :value="item.floor + '楼'" />
          <van-cell title="总楼层" :value="item.totalFloor + '楼'" />
          <van-cell title="是否顶楼" :value="item.houseAtTop" />
          <van-cell title="有无电梯" :value="item.houseElevatorStruct" />
          <van-cell title="正面配套" :value="item.houseEnvPositive" />
          <van-cell title="负面配套" :value="item.houseEnvNegative" />
        </van-cell-group>

        <!-- 房产使用情况 -->
        <van-divider content-position="center">房产使用情况</van-divider>
        <van-cell-group>
          <van-cell title="房产用途" :value="item.housePurpose" />
          <van-cell title="是否出租" :value="item.lease === 'yes' ? '是' : '否'" />
          <van-cell title="租期(月)" v-if="item.lease === 'yes'" :value="item.houseLeaseTerm" />
          <van-cell title="租金(元/月)" v-if="item.lease === 'yes'" :value="item.houseRental" />
          <van-cell title="装修情况" :value="item.decorate | filterHouseDecorateText" />
          <van-cell title="房屋格局" :value="item.houseSpaceRoom" />
          <van-cell title="朝向" :value="item.toward" />
          <van-cell title="是否有改造" :value="item.estateCertificate" />
          <van-cell title="结构异常" :value="item.houseStructChange" />
          <van-cell title="是否有暗房" :value="item.houseNotWindowRoom" />
          <van-cell title="有无未成年/70岁以上老人" :value="item.youngOrOld" />
          <van-cell title="有无卧床病人" :value="item.patient" />
        </van-cell-group>
      </div>

      <!-- 收入与负债情况 -->
      <van-divider content-position="center">收入与负债情况</van-divider>
      <van-cell-group>
        <van-cell title="单位性质" :value="data.comNature" />
        <van-cell title="职务" v-if="data.comJob" :value="data.comJob" />
        <van-cell title="所属行业" v-if="data.comIndustry" :value="data.comIndustry" />
        <van-cell title="经营主体类型" v-if="data.comType" :value="data.comType" />
        <van-cell title="经营年限" v-if="data.comOperateYears" :value="data.comOperateYears" />
        <van-cell title="借款人关系" v-if="data.comToRelational" :value="data.comToRelational" />
        <van-cell title="家庭年收入(元)" v-if="data.familyIncome" :value="data.familyIncome | NumberFormat" />
        <van-cell title="年营业收入" v-if="data.operatingRevenue" :value="data.operatingRevenue + '万元/年'" />
        <van-cell title="年营业利润" v-if="data.operatingProfit" :value="data.operatingProfit + '万元/年'" />
        <van-cell title="总负债" v-if="data.totalLiabilities" :value="data.totalLiabilities + '万元'" />
        <van-cell title="每月还款总额" v-if="data.monthlyRepayment" :value="data.monthlyRepayment + '万元'" />
        <van-cell title="是否有其他收入" v-if="data.ifOtherIncome" :value="data.ifOtherIncome" />
        <van-cell title="其他收入" v-if="data.otherIncome" :value="data.otherIncome" />
      </van-cell-group>
      <van-divider>转贷情况</van-divider>
      <van-cell-group>
        <van-cell title="转贷类型">{{ data.relendType }}</van-cell>
        <van-cell title="上家借款金额(万)">
          {{ ['转贷一押', '转贷二押'].includes(data.relendType) ? data.previousAmount : '/' }}
        </van-cell>
        <van-cell title="上家还款情况">
          {{ ['转贷一押', '转贷二押'].includes(data.relendType) ? data.previousRepayStatus : '/' }}
        </van-cell>
        <van-cell title="转贷原因">
          {{ ['转贷一押', '转贷二押'].includes(data.relendType) ? data.relendNote : '/' }}
        </van-cell>
      </van-cell-group>

      <van-divider>综述</van-divider>
      <van-cell-group>
        <template v-if="!data.checkedFamilyRegister">
          <van-cell title="核验原件">{{ data.checkedCardID }}</van-cell>
        </template>
        <template v-else>
          <van-cell title="身份证检查">{{ data.checkedCardID }}</van-cell>
          <van-cell title="户口本检查">{{ data.checkedFamilyRegister }}</van-cell>
          <van-cell title="房产证检查">{{ data.checkedPropertyCertificate }}</van-cell>
          <van-cell title="结婚证检查">{{ data.checkedMarriageCertificate }}</van-cell>
          <van-cell title="征信检查">{{ data.checkedCreditReporting }}</van-cell>
          <van-cell title="查册检查">{{ data.checkedPropertyRegister }}</van-cell>
          <van-cell title="其他">{{ data.checkedOther }}</van-cell>
        </template>
        <van-cell title="客户配合度">{{ data.customerCooperation }}</van-cell>
        <van-cell title="其他情况与异常" >
          {{ data.riskStatement }}
        </van-cell>
      </van-cell-group>

      <van-divider>其他</van-divider>
      <van-cell-group>
        <van-cell title="下户人员">{{ data.interviewName }}</van-cell>
      </van-cell-group>
    </van-tab>
    <van-tab style="margin-top: 10px" title="下户材料">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="抵押物照片" name="1">
          <oss-upload :applyId="applyId" :groupCode="44" refName="fcnb" :isUpload="auditStatus==2"/>
        </van-collapse-item>
        <van-collapse-item title="证件原件" name="2">
          <oss-upload :applyId="applyId" :groupCode="1003" refName="hyzm" :isUpload="auditStatus==2"/>
        </van-collapse-item>
        <van-collapse-item title="其他" name="4">
          <oss-upload :applyId="applyId" :groupCode="1002" refName="xhcl" :isUpload="auditStatus==2"/>
        </van-collapse-item>
        <van-collapse-item title="下户监控" name="5">
          <oss-upload :applyId="applyId" :groupCode="1004" refName="xhjk" :isUpload="auditStatus==2"/>
        </van-collapse-item>
      </van-collapse>


    </van-tab>
    <van-popup position="bottom" v-model="popupShow" :overlay="true">
      <van-picker title="请选择" show-toolbar :columns="columns"
                  @confirm="onConfirm"
                  @cancel="popupShow=false"/>

    </van-popup>

    <van-popup position="bottom" v-model="popupMultipleShow" :overlay="true">
      <van-picker title="多选"
                  show-toolbar
                  cancel-button-text="关闭"
                  confirm-button-text="选择"
                  :columns="multipleColumns"
                  @confirm="onMultipleSelect"
                  @cancel="onMultipleConfirm"/>

    </van-popup>



    <!--审批意见-->
    <van-dialog
        v-model="auditShow"
        :title="title"
        show-cancel-button
        :before-close="rejected"
        @cancel="auditShow = false"
    >
      <van-field type="textarea" size="large" v-model="remark" :error-message="remarkErr"
                 placeholder="请输入原因"/>
    </van-dialog>

    <!--房产信息下户填写 -->
    <van-popup
            v-model="mortgageShow"
            position="top"
            custom-style="width: 100%;"
            @confirm="onMultipleSelect">
        <warrant-mortgage :mortgageId="mortgageId" v-if="mortgageId" :isReadOnly="isReadOnly"> </warrant-mortgage>
    </van-popup>


  </van-tabs>

</template>

<script>
import {saveInterview, getInterviewByApplyId, auditProcess} from '@/api/loanInfo'
import {mapGetters} from 'vuex'
import {eventBus} from '@/vue/utils/eventBus'
import {dictData} from "@/vue/utils/interviewData";
import FilesUpload from '@/views/home/business/mortgage/files-upload.vue'
import ossUpload from '@/views/component/oss-upload'
import WarrantMortgage from './warrant-mortgage.vue'
import Dialog from "vant/lib/dialog";
import Vue from "vue";
import {getApplyInfoHouses} from "../../../../../api/loanInfo";

export default {
  name: 'warrant-interview',
  props: {
    applyId: {
      type: String,
      default: ''
    }
  },
  watch: {
    'form.houseResidenceEqOwnerCert'(value) {
      if (value === '不一致') {
        this.isAddress = true
      } else {
        this.form.houseResidenceAddr = ''
        this.isAddress = false
      }
    },
    'form.previousRepayStatus'(value) {
      if (value === '有逾期') {
        this.isOverdue = true
      } else {
        this.form.previousRepayOverdue = ''
        this.isOverdue = false
      }
    },
    'form.comNature'(value) {
      if (value.indexOf('自雇') > -1) {
        this.isSelfEmployed = true
      } else {
        this.isSelfEmployed = false
      }
    },
    'form.ifOtherIncome'(value) {
      if (value==='是') {
        this.ifOtherIncome = true
      } else {
        this.ifOtherIncome = false
      }
    },
    'form.relendType'(value) {
      const self=this
      this.relendTypeShow = ['转贷一押', '转贷二押'].includes(value)
      if(this.relendTypeShow){
        setTimeout(() => {
          self.form.relendNote=self.form.relendNote||"";
          self.form.previousAmount=self.form.previousAmount||"";
          self.form.previousRepayStatus=self.form.previousRepayStatus||"";
          self.form.previousRepayOverdue=self.form.previousRepayOverdue||"";
        }, 200)
      }
    }

  },
  components: {
    FilesUpload,
    ossUpload,
    WarrantMortgage
  },
  computed: mapGetters([
    'auditStatus'
  ]),
  data() {
    return {
      mortgageId:undefined,
      mortgageShow:false,
      relendTypeShow: false,
      activeNames: ['1'],
      data:{},
      isReadOnly: false,
      // 单选
      popupShow: false,
      // 多选
      popupMultipleShow: false,
      columns: [],
      multipleColumns: [],
      isAddress: false,//住址与房产证不一致时
      isOverdue: false,//是否逾期的逾期情况
      ifOtherIncome:false,//是否其他收入
      isSelfEmployed: false, // 自雇
      // 对应的字段名称
      field: undefined,
      form: {
        /**
         * 借款人基本情况
         */
        borrowAmount:undefined,  //申请金额
        borrowTerm:undefined,  //申请期限
        borrowPurpose:undefined, //借款用途
        repaymentSource:undefined, //还款来源
        maritalStatus:undefined, //婚姻状态
        houseResidenceEqOwnerCert:undefined, //常住地址
        houseResidenceAddr:undefined,//实际住址
        /**
         * 收入与负债情况
         */
        comNature:undefined, //单位性质
        comJob:undefined,//职务
        comIndustry:undefined,//所属行业
        comType:undefined,//经营主体类型
        comOperateYears:undefined,//经营年限
        comToRelational:undefined,//借款人关系
        operatingRevenue:undefined,//年营业收入
        operatingProfit:undefined,//年营业利润
        totalLiabilities:undefined,//总负债
        monthlyRepayment:undefined,//每月还款总额
        ifOtherIncome:undefined,//是否有其他收入
        otherIncome:undefined,//其他收入
        familyIncome:undefined,//家庭年收入
        /**
         * 转贷情况
         */
        relendType: undefined, //转贷类型
        relendNote: undefined, //转贷原因
        previousAmount: undefined, //上家借款金额
        previousRepayStatus: undefined, //上家还款情况
        previousRepayOverdue: undefined, //逾期情况
        /**
         * 综述
         */
        checkedCardID: undefined, //核验原件
        customerCooperation: undefined, //客户配合度
        riskStatement: undefined, //其他情况与异常

      },
      activate: ['1', '2', '3', '4', '5', '6', '7'],
      content: '',
      editIndex: -1,
      title: '',
      showEdit: false,
      auditShow: false,
      remark: undefined,
      remarkErr: undefined,
      loading: false,
      status: '',//审批状态
      houses:[], //关联房产信息
      houseInfo: {
        houseArea: 0
      }

    }
  },
  mounted() {
    let self = this
    //判断当前进件是否处在尽调/下户阶段
    this.auditStatus == '2' ? this.isReadOnly = false : this.isReadOnly = true
    console.log(this.isReadOnly)
    // 获取下户面谈数据
    this.getInterviewData()
    this.loadHouses()
    setTimeout(() => {
      self.houseInfo = Vue.ls.get('HOUSE_INFO')
    }, 1000)
    //初始化审批事件
    eventBus.$on('warrant-interview-audit', function (status) {
      //审批操作
      self.audit(status)
    })
    eventBus.$on('goBackToInterviewEdit',function () {
      self.mortgageShow=false
      self.mortgageId=null
    })
  },
  destroyed() {
    eventBus.$off('warrant-interview-audit')
    eventBus.$off('goBackToInterviewEdit')
  },
  methods: {
    handleMortgageEdit(house){
      this.mortgageShow=true
      this.mortgageId=house.customerHouseId
    },
    loadHouses () {
      getApplyInfoHouses({ applyId: this.applyId }).then(res => {
        if (res.success) {
          this.houses = res.data
        }
      })
    },
    rejected(action, done) {
      if (action === 'confirm') {
        if (this.remark == '') {
          this.remarkErr = '审批意见不能为空'
          done(false)
          return false
        }
        done()
        const typeMap = {"2": "reject", "4": "abandoned", "5": "denied"}
        //驳回、拒单、客户放弃
        let params = {
          applyId: this.applyId,
          auditType: '2',
          remark: this.remark,
          type: typeMap[this.status],
          process: 'WARRANT_INTERVIEW'
        }
        auditProcess(params).then(res => {
          this.$toast(res.msg)
          if (res.success) {
            this.$router.go(-1)
          }
        })
      } else {
        done()
      }
    },
    getInterviewData() {
      getInterviewByApplyId({applyId: this.applyId}).then(res => {
        if (res.success) {
          this.form = res.data
          this.data = res.data
        } else {
          // 失败读取缓存的表单数据
          if (!this.isReadOnly) {
            const tempData = Vue.ls.get(this.applyId)
            if (tempData != null) {
              this.form = Vue.ls.get(this.applyId)
            }
          }
        }
      })
    },
    // 确认选择
    onMultipleConfirm(value) {
      //this.form[this.field] = value
      this.popupMultipleShow = false
    },
    // 确认选择
    onMultipleSelect(value) {
      let _value = this.form[this.field]
      console.log(_value)
      if (_value) {
        this.form[this.field] = _value + ',' + value
      } else {
        this.form[this.field] = value
      }
      this.$toast('当前选择：' + this.form[this.field])
    },
    // 确认选择
    onConfirm(value) {
      this.form[this.field] = value
      this.popupShow = false
    },
    // 激活弹出选择器
    showPopup(value) {
      // 赋值对应字段
      if (!this.isReadOnly) {
        this.field = value
        this.columns = dictData[value]
        this.popupShow = true
      }
    },
    // 激活弹出多选选择器
    showMuliplePopup(value) {
      if (!this.isReadOnly) {
        // 赋值对应字段
        this.field = value
        this.multipleColumns = dictData[value]
        this.popupMultipleShow = true
      }
    },
    // 提交
    onSubmit(values) {
      
      if (!this.loading) {
        // 需要校验字段数量，因使用了折叠面板
        if (values.length < 54) {
          Dialog.alert({
            message: '请假检查表单是否填写完整'
          })
          return false
        }

        this.form.applyId = this.applyId

        //todo 验证括号里的内容填写
        // 单位性质
        if (this.form.comNature && this.form.comNature.length <= 16) {
          Dialog.alert({
            message: '请补充完整单位性质的公司名称'
          })
          return false
        }

        // 正面配套地铁站检测长度
        if (this.form.houseEnvPositive && this.form.houseEnvPositive.indexOf('地铁站') > -1) {
          let _array = this.form.houseEnvPositive.split(',')
          let result = true
          _array.forEach(item => {
            if (item.indexOf('地铁') > -1 && item.length <= 8) {
              result = false
            }
          })
          if (!result) {
            Dialog.alert({
              message: '请补充完整地铁站名称'
            })
            return false
          }
        }

        // 负面配套：其他
        if (this.form.houseEnvNegative && this.form.houseEnvNegative.indexOf('其他') > -1) {
          let _array = this.form.houseEnvNegative.split(',')
          let result = true
          _array.forEach(item => {
            if (item.indexOf('其他') > -1 && item.length <= 6) {
              result = false
            }
          })
          if (!result) {
            Dialog.alert({
              message: '请补充负面配套的其他信息'
            })
            return false
          }
        }

        // 借款人关系：其他
        if (this.form.comToRelational && this.form.comToRelational.indexOf('其他') > -1 && this.form.comToRelational.length <= 10) {
          Dialog.alert({
            message: '请补充借款人关系的其他信息'
          })
          return false
        }

        // 居住关系：其他
        if (this.form.houseCohabitantRelation && this.form.houseCohabitantRelation.indexOf('其他') > -1) {
          let _array = this.form.houseCohabitantRelation.split(',')
          let result = true
          _array.forEach(item => {
            if (item.indexOf('其他') > -1 && item.length <= 6) {
              result = false
            }
          })
          if (!result) {
            Dialog.alert({
              message: '请补充居住关系的其他信息'
            })
            return false
          }
        }

        // 核验原件
        if (this.form.checkedCardID.indexOf('其他') > -1) {
          let _array = this.form.checkedCardID.split(',')
          let result = true
          _array.forEach(item => {
            if (item.indexOf('其他') > -1 && item.length <= 6) {
              result = false
            }
          })
          if (!result) {
            Dialog.alert({
              message: '请补充核验原件的其他信息'
            })
            return false
          }
        }
        this.loading = true
        // 保存
        saveInterview(this.form).then(res => {
          Dialog.alert({
            message: res.msg
          })
          this.loading = false
        }).finally(() => {
          this.loading = false
        })
      }
    },
    onFailed(errorInfo) {
      // 缓存到本地 localstorage
      Vue.ls.set(this.applyId, errorInfo.values, 1000 * 60 * 60 * 24)
      Dialog.alert({
        message: '请检查表单是否填写完整，本次临时缓存成功'
      })
    },
    audit(status) {
      this.status = status
      switch (status) {
        case "1"://完成下户调查
          let params = {
            applyId: this.applyId,
            process: 'WARRANT_INTERVIEW',
            type: 'pass'
          }
          this.$dialog.confirm({
            title: '提醒',
            message: '下户面谈是否完成?'
          }).then(() => {
            auditProcess(params).then(res => {
              this.$toast(res.msg)
              if (res.success) {
                this.$router.go(-1)
              }
            })
          }).catch(() => {
            // on cancel
          });
          break;
        case "2"://驳回
          this.auditShow = true
          this.title = '驳回原因'
          break
        case "3"://客户放弃
          this.auditShow = true
          this.title = '客户放弃'
          break
        case "4"://拒单
          this.auditShow = true
          this.title = '拒单'
          break
      }
    }
  }
}
</script>

<style scoped>
.htmlContent {
  overflow: auto;
}
</style>
